import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@rebass/grid";
import * as bankAccountHooks from "@rentiohq/shared-frontend/dist/reduxV2/bankAccount/bankAccount.hooks";
import { EBankAccountOwnerType, } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { getOwnerNameError, hasOwnerNameChanged, OWNER_NAME_MAX_LENGTH, } from "@rentiohq/shared-frontend/dist/utils/bankAccount.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { ts } from "../../services";
import { ESpacings } from "../Grid";
import { Labelled } from "../Labelled";
import { Modal } from "../Modal";
import { SegmentedControl } from "../SegmentedControl";
import { TextField } from "../TextField";
import { TextStyle } from "../TextStyle";
export var EditBankAccountOwnerNameModal = function (props) {
    var _a;
    var bankAccount = props.bankAccount, fallbackOwnerType = props.fallbackOwnerType, onClose = props.onClose, onUpdated = props.onUpdated;
    var _b = bankAccountHooks.useUpdateBankAccountOwnerName(), isUpdating = _b.isUpdating, updateOwnerName = _b.updateOwnerName;
    var currentOwnerType = (_a = bankAccount.ownerType) !== null && _a !== void 0 ? _a : fallbackOwnerType;
    var _c = React.useState(bankAccount.ownerName), ownerName = _c[0], setOwnerName = _c[1];
    var _d = React.useState(currentOwnerType), ownerType = _d[0], setOwnerType = _d[1];
    // Errors only show once the broker tried to save, so the modal does not open
    // complaining about a name they have not touched yet.
    var _e = React.useState(false), showError = _e[0], setShowError = _e[1];
    var errorKey = getOwnerNameError({ ownerName: ownerName, ownerType: ownerType });
    // Saving creates a new bank account and a new Mangopay recipient, so Save stays
    // disabled until the edit would change what is stored.
    var hasChanged = hasOwnerNameChanged({
        ownerName: ownerName,
        ownerType: ownerType,
        currentOwnerName: bankAccount.ownerName,
        currentOwnerType: currentOwnerType,
    });
    var handleSubmit = function () {
        if (errorKey) {
            setShowError(true);
            return;
        }
        updateOwnerName({
            id: bankAccount.id,
            data: { ownerName: ownerName, ownerType: ownerType },
            onSuccess: function (updatedBankAccount) {
                onUpdated(updatedBankAccount);
                onClose();
            },
        });
    };
    return (_jsxs(Modal, { heading: getLocalizedText("bank_account.edit_owner_name.heading"), onClose: onClose, actions: [
            {
                content: ts.system("cancel"),
                appearance: "outline",
                onClick: onClose,
            },
            {
                content: ts.system("save"),
                appearance: "primary",
                isDisabled: isUpdating || !hasChanged,
                isSubmitting: isUpdating,
                onClick: handleSubmit,
            },
        ], children: [_jsxs(Box, { mb: ESpacings.base, children: [_jsx(TextStyle, { variation: "strong", element: "div", children: bankAccount.iban }), _jsx(TextStyle, { variation: "subdued", size: "small", children: getLocalizedText("bank_account.edit_owner_name.info") })] }), _jsx(Box, { mb: ESpacings.base, children: _jsx(Labelled, { label: getLocalizedText("bank_account.edit_owner_name.owner_type.label"), children: _jsx(SegmentedControl, { name: "bank-account-owner-type", selected: ownerType, onChange: setOwnerType, disabled: isUpdating, options: [
                            {
                                id: EBankAccountOwnerType.Individual,
                                value: getLocalizedText("bank_account.edit_owner_name.owner_type.individual"),
                            },
                            {
                                id: EBankAccountOwnerType.Business,
                                value: getLocalizedText("bank_account.edit_owner_name.owner_type.business"),
                            },
                        ] }) }) }), _jsx(TextField, { name: "bank-account-owner-name", autoFocus: true, value: ownerName, maxLength: OWNER_NAME_MAX_LENGTH, disabled: isUpdating, label: getLocalizedText("bank_account.owner_name.label"), error: showError && errorKey ? getLocalizedText(errorKey) : undefined, onChange: function (event) {
                    setOwnerName(event.target.value);
                    setShowError(false);
                } })] }));
};
